import React, { useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const cardData = [
  {
    imageUrl: "/assets/edu-training/Objectives.jpg", // Ensure path is correct
    // tag: "  ",
    title: "Core Objectives",
    desc: "A holistic value-based initiative fostering goodness, responsibility, mentorship, cultural preservation, and balanced personal growth to nurture inspired, ethical leaders.",
    link: "/objectives",
  },
  {
    imageUrl: "/assets/edu-training/values.png",
    // tag: "  ",
    title: "Education & Training",
    desc: "A four-phase journey of value-based education—awareness, education, cultivation, and action—guiding students from interest to embodiment of core values.",
    link: "/values",
  },
];

const PremiumCards = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section className="premium-section">
      <div className="premium-bg-grain"></div>
      <div className="premium-container">
        
        <motion.div 
          className="premium-grid" 
          ref={ref}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1, transition: { staggerChildren: 0.2 } }
          }}
        >
          {cardData.map((card, index) => (
            <LuxuryCard key={index} card={card} />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

const LuxuryCard = ({ card }) => {
  const cardRef = useRef(null);
  const [style, setStyle] = useState({});

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const { left, top, width, height } = cardRef.current.getBoundingClientRect();
    
    // Calculate position relative to center (for tilt)
    const x = clientX - left;
    const y = clientY - top;
    const centerX = width / 2;
    const centerY = height / 2;

    // Smoother, subtler tilt (Max 5 degrees)
    const rotateX = ((y - centerY) / centerY) * -3; 
    const rotateY = ((x - centerX) / centerX) * 3;

    // Spotlight position
    const glowX = (x / width) * 100;
    const glowY = (y / height) * 100;

    setStyle({
      transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`,
      "--glow-x": `${glowX}%`,
      "--glow-y": `${glowY}%`,
    });
  };

  const handleMouseLeave = () => {
    setStyle({
      transform: "perspective(1000px) rotateX(0) rotateY(0) scale3d(1, 1, 1)",
      "--glow-x": "50%",
      "--glow-y": "50%",
    });
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
  };

  return (
    <motion.div
      className="luxury-card-wrapper"
      variants={cardVariants}
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={style}
    >
      <div className="luxury-card-inner">
        {/* Image Section */}
        <div className="luxury-image-box">
          <img src={card.imageUrl} alt={card.title} />
          <div className="img-overlay"></div>
        </div>

        {/* Content Section */}
        <div className="luxury-content">
          <div className="content-top">
            <span className="luxury-tag">{card.tag}</span>
            <h2 className="luxury-title">{card.title}</h2>
            <div className="luxury-divider"></div>
            <p className="luxury-desc">{card.desc}</p>
          </div>

          <div className="content-bottom">
            {card.link && (
              <a href={card.link} className="luxury-link-btn">
                <span>Discover More</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </a>
            )}
          </div>
        </div>

        {/* Effects */}
        <div className="luxury-glow"></div>
        <div className="luxury-border"></div>
      </div>
    </motion.div>
  );
};

export default PremiumCards;